'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _lodash = require('lodash');

exports.default = {
    props: ['url', 'html'],
    data: function data() {
        return {
            visible: false,
            mode: 'html',
            thumbnailUrl: null,
            link: null,
            specialSites: ['bdsmlr.com']
        };
    },
    computed: {
        shortenedUrl: function shortenedUrl() {
            if (this.url.length > 100) {
                return (0, _lodash.escape)(this.url.substr(0, 100)) + '...';
            }
            return (0, _lodash.escape)(this.url);
        }
    },
    methods: {
        onImageLoad: function onImageLoad() {
            this.$state.$emit('url_visualisation.updated');
        },
        getOriginalLink: function getOriginalLink($url, $default) {
            var re = new RegExp(this.specialSites.join('|'));
            return re.test($url) ? $url : $default;
        }
    },
    mounted: function mounted() {
        var self = this;
        var unsubscribeUrls = this.$state.dataFlow.subscribeUrls(this.url, function (data) {
            self.thumbnailUrl = data['thumbnail'];
            self.mode = 'image';
            self.visible = true;
            self.link = self.getOriginalLink(data['url'], data['link']);
        });

        setTimeout(function () {
            self.visible = true;
        }, 5000);

        setTimeout(function () {
            unsubscribeUrls();
        }, 60000);
    },
    updated: function updated() {
        this.$state.$emit('url_visualisation.updated');
    }
};


//////////////////
// WEBPACK FOOTER
// ./build/exports-loader.js!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/UrlVisualisation.vue
// module id = CXWZ
// module chunks = 1